// @flow

import isPlainObject from 'lodash/isPlainObject';

type Mapper = (value: any, key: string) => string;

/**
 * Returns a function that recursively applies mapKeys
 * to an object and its child objects
 *
 * @param {Function} fn - this is the function that mapKeys applies to the object
 * @param {bool} enterLists - whether to recursively apply fn to lists
 * @return {Function}
 * Example usage deepMap((v, k) => toCamelCase(k))({ hello_world: { my_world: 'hello' } })
 */
export default function deepMapKeys(fn: Mapper, enterLists: boolean = false) {
  return (obj: Object) => {
    if (!isPlainObject(obj)) {
      if (enterLists && Array.isArray(obj)) {
        return obj.map(deepMapKeys(fn, enterLists));
      } else {
        return obj;
      }
    }
    const mapped = {};
    Object.keys(obj).forEach((key) => {
      const newKey = fn(obj[key], key);
      if (isPlainObject(obj[key]) || (enterLists && Array.isArray(obj[key]))) {
        mapped[newKey] = deepMapKeys(fn, enterLists)(obj[key]);
      } else {
        mapped[newKey] = obj[key];
      }
    });

    return mapped;
  };
}
